<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import { mapActions } from "vuex/dist/vuex.cjs.js";
import Pagination from "../../../components/pagination.vue";
import formatter from "../../../mixins/formatter";
import Swal from "sweetalert2";

export default {
    page: {
        title: "User",
        meta: [
            {
                name: "description",
                content: appConfig.description,
            },
        ],
    },
    components: {
        Layout,
        PageHeader,
        Pagination
    },
    mixins: [
        formatter
    ],
    data() {
        return {
            title: "User",
            totalWingband: 0,
            totalChapters: 0,
            loading: true,
            filter: {
                page: "",
                search: "",
                limit:10,
            },
            data: {
                list: [],
                links: [],
                current_page: 1,
                per_page: 1,
                last_page: 1,
            },
            showModal: false,
            user: {
                id: "",
                password: "",
            },
            showPassword: false,
        };
    },
    created() {
        const total = this.$route.query.totalWingband;
        this.totalWingband = total ? parseInt(total, 10) : 0;
    },
    methods: {
        ...mapActions("user", {
            getUser: "getList",
            deleteUser: "delete",
            changePass: "changePass",
        }),
        toggleShow() {
            this.showPassword = !this.showPassword;
        },
        async populateChapterCount() {
            const res = await this.$store.dispatch("chapter/getAll", { limit: 200 });
            const list = (res?.data?.data && Array.isArray(res.data.data))
                ? res.data.data
                : (Array.isArray(res?.data) ? res.data : []);
            this.totalChapters = list.length;
        },
        hasAllChapters(user) {
            return this.totalChapters > 0
                && user.chapters
                && user.chapters.length >= this.totalChapters;
        },
        filterData() {
            this.initList(1);
        },
        async initList(p) {
            var pl = {
                page: p,
                limit: this.filter.limit,
                sort: "created_at",
                order: "desc",
            };
            if (this.filter.page) {
                pl["page"] = this.filter.page;
            }
            if (this.filter.search) {
                pl["search"] = this.filter.search;
            }
            this.loading = true;
            const data = await this.getUser(pl);
            this.loading = false;
            this.data.list = data.data;
            this.data.links = data.links;
            this.data.current_page = data.current_page;
            this.data.per_page = data.per_page;
            this.data.last_page = data.last_page;
        },
        async userDelete(id) {
            var uid = id
            console.log(uid)
            const confirmed = await Swal.fire({
                title: "Are you sure?",
                text: "You want to delete this User?",
                type: "warning",
                showCancelButton: true,
                padding: "2em",
                icon: "warning",
            }).then((result) => {
                return result.isConfirmed;
            });

            if (confirmed) {
                const res = await this.deleteUser(uid);
                console.log(res.status)
                console.log(res)
                if (res.message == "User deleted successfully!") {
                    Swal.fire({
                        icon: "success",
                        title: "User deleted successfully!",
                        text: res.message,
                    });
                    this.goBack();
                } else {
                    console.log(res)
                    var error = res.data.message;
                    Swal.fire({
                        title: "Failed!",
                        text: error,
                        icon: "error",
                        type: "error",
                    });
                }
            }
        },
        goTo() {
            this.$router.push({ path: "/user/create" });
        },
        updateUser(id) {
            this.$router.push({
                path: "/user/view",
                query: {
                    id: id,
                },
            });
        },
        viewStatistics(id) {
            this.$router.push({
                path: "/user/statistics",
                query: {
                    id: id,
                },
            });
        },
        openChangePassModal(id) {
            this.showModal = true;
            this.user.id = id
        },
        closeModal() {
            this.showModal = false;
        },
        async updatePass() {
            var pl = {
                id: this.user.id,
                password: this.user.password
            }
            console.log(pl.id)
            console.log(pl.password)
            const confirmed = await Swal.fire({
                title: "Are you sure?",
                text: "You want to change the password of this Account?",
                type: "warning",
                showCancelButton: true,
                icon: "warning",
                padding: "2em",
            }).then((result) => {
                return result.isConfirmed;
            });
            if (confirmed) {

                const res = await this.changePass(pl);
                console.log(res);
                if (res.message == "User updated succesfully!") {
                    Swal.fire({
                        icon: "success",
                        title: "Updating succeed",
                        text: res.message,
                    });
                    this.showModal = false;
                    this.user.password = "";
                } else {
                    var error = res.message;
                    Swal.fire({
                        icon: "error",
                        title: "Failed!",
                        type: "error",
                        text: error,
                    });
                }
            }
        },
    },
    mounted() {
        this.populateChapterCount();
        this.initList(1);
    },
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items">
            <button class="btn btn-info text-white" @click="$refreshPage()"><i class='bx bx-refresh'></i> Refresh</button>
        </PageHeader>
        <div class="row">
            <div class="col-lg-12">
                <div class="card p-0">
                    <div class="card-body p-0">
                        <div class="d-flex flex-wrap px-3 pt-1">
                            <div class="col-12">
                                <div class="d-flex flex-wrap gap-2 h-100">
                                    <div class="d-flex align-items-end">
                                        <div class="disflex custom-border p-1">
                                            <label class="filter-label">Search:</label>
                                            <input type="text" class="form-control" placeholder="Search..."
                                                v-model="filter.search">
                                            <button class="btn btn-success ms-2" data-toggle="tooltip"
                                                data-placement="top" title="Apply" @click="filterData()">Search</button>
                                        </div>
                                    </div>
                                    <div class="d-flex justify-content-start align-items-end h-100">
                                        <div class="custom-border p-1">
                                            <button class="disflex btn btn-primary" @click="goTo()">
                                                <i class="bx bx-user-plus fs-5 me-1"></i>
                                                User Create
                                            </button>
                                        </div>
                                        <div class="d-flex align-items-end">
                                            <div class="disflex custom-border p-1">
                                                <label class="filter-label">Limit:</label>
                                                <select class="form-control w-25" v-model.lazy="filter.limit" @change="filterData()">
                                                    <option value="10">10</option>
                                                    <option value="25">25</option>
                                                    <option value="50">50</option>
                                                    <option value="100">100</option>
                                                    <option value="200">200</option>
                                                    <option value="500">500</option>
                                                    <option value="1000">1000</option>
                                                    <option value="5000">5000</option>
                                                </select>   
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="pt-3 custom-overflow">
                            <table class="mb-0 table">
                                <thead>
                                    <tr class="bg-light">
                                        <th>#</th>
                                        <th>Title</th>
                                        <th>Username</th>
                                        <th>Contact Number</th>
                                        <th>Chapters</th>
                                        <th>Date Created</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody v-if="!loading">
                                    <tr v-for="(data, index) in data.list" :key="index">
                                        <td>
                                            {{ index + 1 + (this.data.current_page - 1) * this.data.per_page }}
                                        </td>
                                        <td>
                                            <span v-if="data.role == 1">Admin</span>
                                            <span v-if="data.role == 2">Viewer</span>
                                            <span v-if="data.role == 3">Encoder</span>
                                        </td>
                                        <td>{{ data.username }}</td>
                                        <td>{{ data.contact_number }}</td>
                                        <td>
                                            <template v-if="data.chapters && data.chapters.length > 0">
                                                <span v-if="hasAllChapters(data)" class="badge bg-success">ALL CHAPTERS</span>
                                                <template v-else>
                                                    <span
                                                        v-for="c in data.chapters"
                                                        :key="c.id"
                                                        class="badge bg-primary me-1 mb-1"
                                                    >{{ c.chapter }}</span>
                                                </template>
                                            </template>
                                            <span v-else class="text-muted">—</span>
                                        </td>
                                        <td>{{ dateTime(data.created_at) }}</td>                                        <td>
                                            <div class="text-end w-75">
                                                <button v-if="data.role == 3" type="btn"
                                                    class="action-btn btn-light mx-1" data-toggle="tooltip"
                                                    data-placement="top" title="Statistics"
                                                    @click="viewStatistics(data.id)">
                                                    <i class="bx bx-data fs-5"></i>
                                                </button>
                                                <button type="btn" class="action-btn btn-info mx-1"
                                                    data-toggle="tooltip" data-placement="top" title="Edit"
                                                    @click="updateUser(data.id)">
                                                    <i class="bx bx-edit fs-5"></i>
                                                </button>
                                                <button type="btn" class="action-btn btn-warning mx-1"
                                                    @click="openChangePassModal(data.id)" data-toggle="tooltip"
                                                    data-placement="top" title="Change Password">
                                                    <i class="bx bx-lock-alt fs-5"></i>
                                                </button>
                                                <button type="btn" class="action-btn btn-danger mx-1"
                                                    data-toggle="tooltip" data-placement="top" title="Delete"
                                                    @click="userDelete(data.id)">
                                                    <i class="bx bx-trash fs-5"></i>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <div v-if="loading" class="loader">Loading...</div>
                        </div>
                    </div>
                    <Pagination :data="data" @emitPage="initList" class="me-2" />
                </div>
            </div>
        </div>
        <div class="col-sm-6 col-md-4 col-xl-3">
            <div class="my-4 text-center">
                <b-modal v-model="showModal" id="modal-standard" centered title="Change Password" title-class="font-18"
                    hide-footer>
                    <div>
                        <div class="position-relative">
                            <label class="mt-2 mb-2">New Password:</label>
                            <input class="form-control w-100" :type="showPassword ? 'text' : 'password'"
                                v-model="this.user.password" placeholder="Enter new password...">
                            <i @click="toggleShow" class="eye-btn">
                                <span class="icon is-small is-right">
                                    <i class="fas"
                                        :class="{ 'fa-eye-slash': showPassword, 'fa-eye': !showPassword }"></i>
                                </span>
                            </i>
                            <p v-if="errorMessage" class="error">{{ errorMessage }}</p>
                        </div>
                    </div>
                    <div class="modal-footer mt-3 pb-0">
                        <div class="d-flex justify-content-end align-items-center w-100">
                            <button class="btn btn-secondary text-white mx-1" @click="closeModal()">Cancel</button>
                            <button class="btn btn-success text-white mx-1" @click="updatePass()">Submit</button>
                        </div>
                    </div>
                </b-modal>
            </div>
        </div>
    </Layout>
</template>

<style scoped>
th,
td {
    width: 75px !important;
    text-align: start;
}

.table> :not(caption)>*>* {
    text-align: center;
    padding: .5rem .1rem .5rem .1rem !important;
}

th {
    text-transform: uppercase;
}

.eye-width {
    border-radius: 0px !important;
}

.eye-btn {
    background-color: transparent;
    border: none;
    color: rgb(109, 109, 109) !important;
    border-radius: 0px !important;
    position: absolute;
    cursor: pointer;
    right: 15px;
    top: 45px;
}
</style>